import controller from './my-payments-list.controller';
import template from './my-payments-list.view.html';

let MyPaymentsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MyPaymentsListComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-list/my-payments-list.component.js
 **/